import type { CSSProperties, ReactNode } from 'react';
import { LoadingIndicator } from '../LoadingIndicator/LoadingIndicator';

interface LoadingBlurProps {
    loading?: boolean;
    className?: string;
    style?: CSSProperties | undefined;
    children?: ReactNode;
    contrast?: boolean;
    variant?: 'orbit' | 'ripple';
}

export function LoadingBlur({
    loading,
    className,
    style,
    children,
    contrast,
    variant = 'orbit',
}: LoadingBlurProps): ReactNode {
    return (
        <>
            {loading ? (
                <div
                    className={[
                        'loading-blur-container overflow-hidden',
                        variant === 'ripple'
                            ? 'loading-blur-ripple-mode'
                            : undefined,
                        className,
                        contrast ? 'contrast' : undefined,
                    ].join(' ')}
                    style={style}
                >
                    <div
                        className={[
                            'loading-blur',
                            variant === 'ripple'
                                ? 'loading-blur-ripple'
                                : undefined,
                        ].join(' ')}
                        style={style}
                    ></div>
                    {variant === 'ripple' ? (
                        <LoadingIndicator variant="ripple" />
                    ) : (
                        <div className="orbit" />
                    )}
                </div>
            ) : null}
            {children}
        </>
    );
}
